import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviourSubjectService } from './behaviour-subject.service';
import { Router } from '@angular/router';
import { secureStorage } from './encryption/secureservice';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from './cookie.service';
@Injectable({
  providedIn: 'root'
})
export class RootService {
  expiredDate: any;
  readonly options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'request-id': 'b997a77ae2b3f30c1bed151c3e42434f',
    }),
  };
  showServicecall: any = false;
  constructor(private http: HttpClient,
    private localStorage: secureStorage,
    @Inject(PLATFORM_ID) private platformId: Object,
     private behaviorService: BehaviourSubjectService, private router: Router, private ssrcookieService: CookieService, private localstorage: secureStorage, private toastrService:ToastrService) { }


  getBrowserID() {
    return this.platformId;
  }
  getUserId() {
    return this.ssrcookieService.getItem("userId")
      ? this.ssrcookieService.getItem("userId")
      : null;
  }
  getRefreshToken() {
    return this.ssrcookieService.getItem('refresh_token');
  }
  upgradeVersion() {
    if (isPlatformBrowser(this.platformId)) {
      const APP_VERSION = environment?.version;
      if (typeof localStorage["APP_VERSION"] === 'undefined' || localStorage["APP_VERSION"] === null) {
        // localStorage.clear();
        // this.deleteCookies();
        localStorage.setItem('APP_VERSION', APP_VERSION);
      }
      if (localStorage["APP_VERSION"] != APP_VERSION) {
        // localStorage.clear();
        // this.deleteCookies();

        localStorage.setItem('APP_VERSION', APP_VERSION);
      }
    }
  }
  async getFreeSearchToken(isError?: any): Promise<any> {

    if (isPlatformBrowser(this.platformId)) {
    let device_id;
    let deviceid;
    deviceid = this.ssrcookieService.getItem('uniqueId') ? this.ssrcookieService.getItem('uniqueId') : null;
    if (deviceid) {
      device_id = deviceid;
    } else {
      var result = '';
      let random: any;
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 10; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      random = Date.now() + Math.floor(Math.random() * 100000000000000000000)
      random += Math.floor(Math.random() * 100000000000000000000)
      random += result
      this.ssrcookieService.setItem('uniqueId', random,);
      device_id = random
    }

    let user = {
      "device_id": device_id,
    }
    const promise = await this.http.post(`${environment.apiUrl}api/v1/cv_online/FreeSearchTokenRequest/`, user, this.options).toPromise()
      .then((response: any) => {
        if (response) {
          this.expiredDate = new Date();
          let Minutes = response.data['expires_in'] * 1000000000000000000;
          var expirein = (Minutes - (Minutes / 10))
          let expiredate2 = new Date(this.expiredDate.getTime() + expirein);
          this.ssrcookieService.setItem('access_token', response.data['access_token'], expiredate2 );
          this.ssrcookieService.setItem('refresh_token', response.data['refresh_token']);
          localStorage.setItem('ref_token', response.data['refresh_token']);

          this.ssrcookieService.setItem('FreeRefreshTokenInProgress', 'false');
          this.behaviorService.freeSearchTokenUpdated.next(true);
          if (isError) {
            this.toastrService.warning("Server Error Please Try Again After Sometime")
            // this.router.navigateByUrl(this.router.url);
            return
          }
        }
        return
      }).catch((error) => {
        this.toastrService.warning(error)
        return;
      })
    return promise;
  }
}

  private storeJwtToken(response: any) {

    if (isPlatformBrowser(this.platformId)) {
    if (response['success'] === true) {
      this.expiredDate = new Date();
      let Minutes = response.data['expires_in'] * 1000;
      var expirein = (Minutes - (Minutes / 10))
      let expiredate2 = new Date(this.expiredDate.getTime() + expirein);

      this.ssrcookieService.setItem('access_token', response.data['access_token'], expiredate2 );
      this.ssrcookieService.setItem('refresh_token', response.data['refresh_token']);
      this.localstorage.setItem('ref_token', response.data['refresh_token']);
      this.localstorage.setItem('refreshTokenInProgress', 'false');

    }
  }
  }

  jwt_decode(response: any) {
    if (response['success'] === true) {
      this.expiredDate = new Date();
      let Minutes = response.data['expires_in'] * 1000;
      var expirein = (Minutes - (Minutes / 10))
      let expiredate2 = new Date(this.expiredDate.getTime() + expirein);

      this.ssrcookieService.setItem('access_token', response.data['access_token'], expiredate2 );
      this.ssrcookieService.setItem('refresh_token', response.data['refresh_token']);
      this.ssrcookieService.setItem('FreeRefreshTokenInProgress', 'false');
      this.behaviorService.freeSearchTokenUpdated.next(true);

    }
  }

  async refreshToken(isError?): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {

      let device_id;
      let deviceid;
      deviceid = this.ssrcookieService.getItem('uniqueId') ? this.ssrcookieService.getItem('uniqueId') : null;
      if (deviceid) {
        device_id = deviceid;
      } else {
        var result = '';
        let random;
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < 10; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        random = Date.now() + Math.floor(Math.random() * 100000000000000000000)
        random += Math.floor(Math.random() * 100000000000000000000)
        random += result
        this.ssrcookieService.setItem('uniqueId', random);
        device_id = random
      }

      let user = {
        "device_id": device_id,
      }
      this.showServicecall = true;
      const promise = this.http.post(`${environment.apiUrl}api/v1/cv_online/FreeSearchTokenRequest/`, user, this.options).toPromise()
        .then((response: any) => {
          if (response) {
            this.showServicecall = false;
            this.expiredDate = new Date();
            let Minutes = response.data['expires_in'] * 1000;
            var expirein = (Minutes - (Minutes / 10))
            let expiredate2 = new Date(this.expiredDate.getTime() + expirein);

            this.ssrcookieService.setItem('access_token', response.data['access_token'], expiredate2);
            this.ssrcookieService.setItem('refresh_token', response.data['refresh_token']);
            this.localStorage.setItem('refresh_token', response.data['refresh_token']);
            this.localStorage.setItem('FreeRefreshTokenInProgress', 'false');
            this.behaviorService.freeSearchTokenUpdated.next(true);
            if(isError){
            this.router.navigateByUrl(this.router.url);
            }

          }
          return
        //   false
        // }).catch((error)=>{
        //   return error
        })
      return promise;
      }
}


refreshToken2(): Promise<any> {

  if (isPlatformBrowser(this.platformId)) {
  let refreshToken = this.ssrcookieService.getItem("refresh_token")
  let data = {}
  data = {
    refresh_token: refreshToken
  }
  this.showServicecall = true;
  const promise1 = this.http.post(`${environment.apiUrl}api/v1/cv_online/token/refresh/`, data, this.options).toPromise()
    .then((response: any) => {
      this.showServicecall = false;
      if (response['success'] === true) {
        this.localStorage.setItem('FreeRefreshTokenInProgress', 'false');
        this.storeJwtToken(response);
      }
      return;
    }).catch(() => {
      return;
    });
  return promise1;
}
}

loginUser(response: any) {
  this.setToken(response.token.token);
  this.setUser(response);
  this.setUserId(response);
  this.behaviorService.isLoggedIn.next(true);
}
getUserData() {

  if (isPlatformBrowser(this.platformId)) {

    return JSON.parse(this.localStorage.getItem('userData'));
  }
}
setToken(data: any) {
  let TodaysDate = new Date();
  let accessMinutes = data.expires_in * 1000;
  var accessExpiresIn = (accessMinutes - (accessMinutes / 10))
  let accessExpiryDate = new Date(TodaysDate.getTime() + accessExpiresIn);
  this.ssrcookieService.setItem('access_token', data.access_token, accessExpiryDate);
  this.ssrcookieService.setItem('refresh_token', data.refresh_token);
}
setUser(data:any) {

  if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem("userData", JSON.stringify(data));
  }
}
setUserId(data:any) {
  this.ssrcookieService.setItem("userId", JSON.stringify(data.id))
}

  logout() {


    this.ssrcookieService.removeItem("access_token");
    this.ssrcookieService.removeItem("refresh_token");
    this.ssrcookieService.removeItem("userId");
    this.behaviorService.isLoggedIn.next(false);
    if (isPlatformBrowser(this.platformId)) {
      const APP_VERSION = environment.version;
      localStorage.setItem("APP_VERSION", APP_VERSION);
      localStorage.removeItem("userData");
      localStorage.removeItem("refreshTokenInProgress");
      localStorage.removeItem("optyData");
      localStorage.removeItem("loginNumber");
      localStorage.removeItem("dealercd");
      localStorage.removeItem("dealername");
      this.localStorage.clear();
      localStorage.removeItem('userPincode');
    }

  }
  isLoggedIn() {
    // return of(
  if (isPlatformBrowser(this.platformId)) {

    return this.ssrcookieService.getItem("access_token") &&
      this.ssrcookieService.getItem("refresh_token") &&
      this.ssrcookieService.getItem("userId")  &&
      this.localStorage.getItem('userData')
      ? true
      : false
    // );
  }
  }
    getWhatAppKycData(){
    if(isPlatformBrowser(this.platformId)){
      if (window.location.href.includes('verify-kyc')) {
        const queryString = window.location.href.split('?')[1];
        if (!queryString) return;

        let decoded = decodeURIComponent(queryString).replace(/ /g, '+');
        const decryptedData = this.localStorage.decryptData(decoded);
        const storeData = decryptedData.split('&');

        console.log('storeData', storeData);

        const parsedData: { [key: string]: any } = {};
        storeData.forEach(entry => {
          const [key, ...valueParts] = entry.split('=');
          let value = valueParts.join('=');
          try {
            value = JSON.parse(value);
          } catch {
            // Not JSON, keep as string
          }
          parsedData[key] = value;
        });

        const now = new Date();
        const expiresInMs = parsedData['expires_in'] * 1000;
        const adjustedExpiry = new Date(now.getTime() + expiresInMs * 0.9); // 90% of expiry time

        // Set access and refresh tokens with expiry
        this.localStorage.setItem('expires_in', adjustedExpiry.getTime().toString());
        this.ssrcookieService.setItem('access_token', parsedData['access_token'], adjustedExpiry);
        this.ssrcookieService.setItem('refresh_token', parsedData['refresh_token']);
        this.localStorage.setItem('ref_token', parsedData['refresh_token']);
        this.localStorage.setItem('refreshTokenInProgress', 'false');

        console.log('decryptedData', decryptedData);
        return parsedData
        // Optional: this.storageService.loginUser();
    }
    }
  }
}
